/**
 * Config var shared across components
 */

// Height of a cell, or 'row', display height of an entry in the tree
export const CELL_HEIGHT = 60
